import { alphabeticalSorting, } from "../../sorters";
import { SortingConfiguration } from "../../../Typings";
import { sortLeaguesByOrderId } from "../sortLeaguesByOrderId";
export const sortLeagues = (leagues, config, sportId) => {
    if (config.sortingLogic === SortingConfiguration.Alphabetically
        && (config.sportsExcludedFromAlphabeticalSorting.indexOf(sportId) === -1)) {
        return leagues.sort((x, y) => alphabeticalSorting(x, y, config.locale));
    }
    else {
        return leagues.sort(sortLeaguesByOrderId);
    }
};
//# sourceMappingURL=sortLeagues.js.map